<template>
  <sweet-modal width='500' blocking title="History" ref="modalHistory">
    <div v-if="historyList.length" class="project-history tab-content">

      <el-button v-if="reverse" style="margin: 0px 0px 10px 203px;" @click="sort" size="mini" circle icon="el-icon-caret-top"></el-button>
      <el-button v-if="!reverse" style="margin: 0px 0px 10px 203px;" @click="sort" size="mini" circle icon="el-icon-caret-bottom"></el-button>

      <ul class="vertical-timeline">
        <li v-for="(item, index) in historyList" :key="index">
          <div class="date">
            <div class="date__date">{{moment(item.datetime.toString(), 'X').format('DD MMMM YYYY')}}</div>
            <div class="date__time">{{moment(item.datetime.toString(), 'X').format('h:mm:ss a')}}</div>
          </div>
          <div class="icon-container">
            <span class="in_progress" :style="{background: item.logAction.color}">
              <img :src="getImage(item.logType.icon)" width="18px;">
            </span>

            <span v-if="item.label == 'in_progress'" class="in_progress">
              <span style="font-size: 50px; margin-top: -8px;">·</span>
            </span>
            <span v-if="item.label == 'error'" class="error">
              <i class="el-icon-loading" style="color: white;"></i>
            </span>
            <span v-if="item.label == 'delivered'" class="delivered">
              <i class="el-icon-check" style="color: white;"></i>
            </span>
            <span v-if="item.label == 'out_off_delivery'" class="out_off_delivery">
              <i class="el-icon-box" style="color: white;"></i>
            </span>
          </div>
          <div class="info">
            <div class="top">
              <div class="top__img">
                <!-- <img :src="getImageByCountry(item.current_country)" height="12px" style="margin-right: 10px;"> -->
              </div>
              <div>
                <span class="top__status">{{ $t(`${item.translationKey}`) }} {{ item.taskName ? '[ ' + $t('history_task_name') + item.taskName + ' ]' : '' }} {{ item.userId2 ? '[ ' + $t('history_name') + item.userName2 + ' ]' : '' }}</span>
              </div>
            </div>
            <div class="top__description">{{item.userName}}</div>
          </div>
        </li>
      </ul>

    </div>
  </sweet-modal>
</template>

<script>
  import moment from 'moment'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  export default {
    name: 'modal-history',
    props: ['historyList'],
    components: {
      SweetModal,
    },
    data() {
      return {
        moment:moment,
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',

        reverse: false,
      }
    },
    methods: {
      openModal() {
        this.$refs.modalHistory.open()
      },
      sort() {
        this.reverse = !this.reverse
        this.historyList.reverse()
      },
      getImage(img) {
        return require(`@/assets/img/history/${img}.svg`);
      },
    },
  }
</script>

<style lang="scss" scoped>
// timeline
ul.vertical-timeline {
  padding: 0;
  margin-left: 215px;
  }

ul.vertical-timeline li {
  list-style-type: none;
  padding: 1em;
  margin: 0;
  transition: background-color 0.5s;
  overflow: visible;
  border-left: 2px solid #eaeaea;
}

ul.vertical-timeline li .date {
  display: inline-block;
  float: left;
  margin-left: -150px;
  max-width: 110px;
  margin-top: 5px;
  &__date {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
  }
  &__time {
    font-size: 11px;
    color: #888;
    text-align: right;
  }
}
ul.vertical-timeline li .icon-container {
  display: inline-block;
  float: left;
  width: 34px;
  height: 34px;
  line-height: 40px;
  border: 2px solid #eaeaea;
  border-radius: 50%;
  margin-left: -33px;
  background: #F7F8FA;
  %status {
    display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    line-height: 40px;
    border-radius: 50%;
    color: #eaeaea;
  }
  .in_progress {
    @extend %status;
    background: #F7F8FA;
  }
  .error {
    @extend %status;
    background: #f56c6c;
  }
  .delivered {
    @extend %status;
    background: #67c23a;
  }
  .out_off_delivery {
    @extend %status;
    background: #e6a23c;
  }
}
ul.vertical-timeline li .info {
  text-align: left;
  // background: #F7F8FA;
  margin-left: 15px;
  margin-bottom: 4px;
  // padding: 10px;
  font-size: 14px;
  .top {
    display: flex;
    &__img {
      // margin-top: 5px;
    }
    &__status {
      font-size: 12px;
      margin-right: 10px;
      font-weight: bold;
    }
    &__description {
      font-size: 11px;
      color: #888;
      // margin-left: 22px;
    }
  }
}
.box {
  max-height: 600px;
  overflow-y: auto;
}
</style>